import { defineMessages, type MessageDescriptor } from 'react-intl-next';

const messages: Record<
	| 'inferredProject'
	| 'inferredProjectTrigger'
	| 'loading'
	| 'loadError'
	| 'basedOnPrefix'
	| 'teamworkGraphActivityAndSource'
	| 'suggestedContributors'
	| 'noSuggestedContributors'
	| 'showAllContributors',
	MessageDescriptor
> = defineMessages({
	inferredProject: {
		defaultMessage: 'Suggested project',
		description: 'Label shown on the inferred project card and inline project chip',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.inferredProject',
	},
	inferredProjectTrigger: {
		defaultMessage: '{projectName}: Suggested project',
		description: 'Accessible label for the suggested project chip trigger',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.inferredProjectTrigger',
	},
	loading: {
		defaultMessage: 'Loading project details',
		description: 'Status shown while inferred project details load',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.loading',
	},
	loadError: {
		defaultMessage: 'Project details could not be loaded.',
		description: 'Error shown when inferred project details fail to load',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.loadError',
	},
	basedOnPrefix: {
		defaultMessage: 'based on',
		description: 'Prefix for the inferred project source attribution',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.basedOnPrefix',
	},
	teamworkGraphActivityAndSource: {
		defaultMessage: 'Teamwork Graph activity and this source',
		description: 'Source attribution for an inferred project based on Teamwork Graph activity',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.teamworkGraphActivityAndSource',
	},
	suggestedContributors: {
		defaultMessage: 'Suggested contributors',
		description: 'Heading for the inferred project contributors section',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.suggestedContributors',
	},
	noSuggestedContributors: {
		defaultMessage: 'No suggested contributors',
		description: 'Empty state for the inferred project contributors section',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.noSuggestedContributors',
	},
	showAllContributors: {
		defaultMessage: 'Show all',
		description: 'Action to reveal all suggested contributors for an inferred project',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.showAllContributors',
	},
});

export default messages;
